import { type EntitiesCalendar } from '../../../states/entities/calendar';
import { type CalendarState } from '../../../states/entities/calendar';
import { type StateType } from '../../../states/index';
import { type Selector } from '../../../types/selectors';
import { selectUserCalendarPrefs } from '../../user/userPrimary.selector';
import { selectEntitiesState } from '../entitiesPrimary.selector';

export const selectEntitiesCalendar: Selector<EntitiesCalendar | undefined> = (state: StateType) =>
  selectEntitiesState(state).calendar;

//#region state.entities.calendar
export const selectEntitiesCalendarEntity: Selector<CalendarState | undefined> = (state: StateType) => {
  const calendar = selectEntitiesCalendar(state) ?? {};
  const calendarPrefs = selectUserCalendarPrefs(state);
  return calendar?.[calendarPrefs.hour];
};
//#endregion

//#region state.entities.calendar[calendarPrefs.hour]
export const selectEntitiesCalendarEntityCalendarId: Selector<number | undefined> = (state: StateType) =>
  selectEntitiesCalendarEntity(state)?.calendarId;

export const selectEntitiesCalendarEntityMatchCount: Selector<number | undefined> = (state: StateType) =>
  selectEntitiesCalendarEntity(state)?.matchCount;

export const selectEntitiesCalendarEntityMatches: Selector<Array<number> | undefined> = (state: StateType) =>
  selectEntitiesCalendarEntity(state)?.matches;
//#endregion
